The details of the unposted position profile to be deleted.
